import { VariableTags } from "app/ApiClient";

export const variableTagsFilterKey = "variableTags" as const;

export const variableTagLabelsConfig = [
  { label: "Sync Pending", value: VariableTags.SyncPending },
  { label: "Sync Complete", value: VariableTags.SyncComplete },
  { label: "Edited", value: VariableTags.Edited },
  { label: "Recoded", value: VariableTags.Recoded },
  { label: "Filtered", value: VariableTags.Filtered },
  { label: "Excluded", value: VariableTags.Excluded },
  { label: "Cleaned", value: VariableTags.Cleaned },
];

export enum VariableTagLabels {
  SyncPending = "Sync Pending",
  SyncComplete = "Sync Complete",
  Edited = "Edited",
  Recoded = "Recoded",
  Filtered = "Filtered",
  Excluded = "Excluded",
  Cleaned = "Cleaned",
}

export const ProjectDataTableConfig = {
  DefaultPageSize: 5000
}

export const DATASET_PAGINATION_OPTIONS = [50, 100, 500, 1000, 5000, 10000, 20000, 50000, 100000];
